import { addDays, differenceInDays, startOfDay } from 'date-fns';
import { toLocalDate } from './itineraryDocumentUtils';

// An evening event that ends in the small hours (18:00–02:00) belongs to the
// night it started, not to the next day as well.
export const OVERNIGHT_END_CUTOFF_HOUR = 6;

const toDate = (value) => {
  if (value instanceof Date) return Number.isNaN(value.getTime()) ? null : value;
  return value ? toLocalDate(value) : null;
};

/**
 * Calendar days an itinerary item occupies, in local wall-clock time.
 *
 * @param {string|Date} start item start_datetime
 * @param {string|Date|null} end item end_datetime
 * @returns {{ firstDay: Date, lastDay: Date, daySpan: number } | null}
 */
export const getItineraryItemDayRange = (start, end) => {
  const startDate = toDate(start);
  if (!startDate) return null;
  const firstDay = startOfDay(startDate);
  const endDate = toDate(end);
  let lastDay = endDate && endDate > startDate ? startOfDay(endDate) : firstDay;

  const endsInSmallHours = endDate
    && lastDay > firstDay
    && endDate.getHours() < OVERNIGHT_END_CUTOFF_HOUR
    && endDate - startDate < 24 * 60 * 60 * 1000;
  if (endsInSmallHours) {
    lastDay = addDays(lastDay, -1);
  }

  return { firstDay, lastDay, daySpan: differenceInDays(lastDay, firstDay) + 1 };
};

export const isItineraryItemOnDay = (item, day) => {
  const range = getItineraryItemDayRange(item?.start_datetime, item?.end_datetime);
  if (!range) return false;
  const current = startOfDay(day);
  return current >= range.firstDay && current <= range.lastDay;
};
